var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-2 text-left p-3 bg-light border border-white",class:_vm.classCustom},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-2"},[_c('span',[_c('img',{staticClass:"rounded-circle d-inline",attrs:{"width":"35px","src":require("@/assets/images/oliver-b-1.png"),"alt":""}})]),_c('strong',{staticClass:"ml-2"},[_vm._v("Tips")])])
}]

export { render, staticRenderFns }